// Import the functions you need from the SDKs you need 
import { initializeApp } from "firebase/app"; 
import { initializeFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration 
// Minimal configuration to avoid installations API issues
const firebaseConfig = { 
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDtdI4YsdLALrUM6sbOS9R5mHnx14TRWeU", 
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "life-and-wellness-center.firebaseapp.com", 
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "life-and-wellness-center", 
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "life-and-wellness-center.appspot.com", 
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "912245579214", 
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:912245579214:web:877ca782480d2d095a1f9f", 
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-XF6FW6CPNS" 
};


// Initialize Firebase 
const app = initializeApp(firebaseConfig); 

// Helpful debug: log which Firebase project the app is using
if (typeof window !== 'undefined') {
  // Only log once per page load
  if (!window.__firebaseConfigLogged) {
    window.__firebaseConfigLogged = true;
    // Log key parts so we can verify project alignment with the Console
    console.info('[Firebase] Using project:', app?.options?.projectId);
    console.info('[Firebase] Auth domain:', firebaseConfig.authDomain);
    console.info('[Firebase] Host:', window.location.host);
  }
}

// Add error handling for Firebase installations
if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', (event) => {
    if (event.reason && event.reason.message && 
        event.reason.message.includes('installations/request-failed')) {
      // Suppress Firebase installations errors as they don't affect functionality
      event.preventDefault();
      console.warn('Firebase Installations error suppressed (does not affect functionality)');
    }
  });
}

// Temporarily disable analytics to avoid permission errors
// const analytics = getAnalytics(app); 
// Use initializeFirestore to improve reliability of dev networking
const db = initializeFirestore(app, {
  // FORCE Long Polling to avoid "net::ERR_ABORTED" loops caused by WebSocket instability in preview environments
  experimentalForceLongPolling: true,
});
const storage = getStorage(app);
const auth = getAuth(app); // Initialize auth

// Update the export
export { app, db, storage, auth, firebaseConfig };